import type { ComponentType } from 'react';
import React from 'react';
import hoistStatics from 'hoist-non-react-statics';

import { generateStyle } from './generate-style';
import type { TWrapper, TOptions } from './models';

/**
 * Вернуть объект с названием виджета
 */
export const getDisplayName = <U,>(TargetWidget: ComponentType<React.PropsWithChildren<U>>) => ({
    displayName: TargetWidget.displayName || TargetWidget.name || 'UnnamedWidget',
});

/**
 * Создать обертку, добавляющую стайлер и зависимости
 */
export const createWrapper =
    <T, U extends T>(
        Widget: ComponentType<React.PropsWithChildren<U>>,
        dependencies?: T,
        options?: TOptions
    ): ComponentType<React.PropsWithChildren<TWrapper<T, U>>> =>
    ({ className, styler, ...props }) =>
        (
            <Widget
                {...dependencies}
                {...(props as U)}
                {...generateStyle(styler, className, options)}
            />
        );

/**
 * Добавить изначальные свойства виджета, displayName и любые дополнительные
 */
export const hoist = <T, U>(
    Wrapper: ComponentType<React.PropsWithChildren<T>>,
    Widget: ComponentType<React.PropsWithChildren<U>>,
    ...rest: any[]
): ComponentType<React.PropsWithChildren<T>> =>
    Object.assign(hoistStatics(Wrapper, Widget), getDisplayName(Widget), ...rest);
